import React from "react";
import SimpleButtonWrapper from "../../simpleButtonWrapper/simpleButtonWrapper";
import Button from "../../button/button";
import PopupMessage from "../../popupMessage/popupMessage";
import { Link } from "react-router-dom";

// `url` is resolved by the parent (ApiProductHOC) against the live product list - this used
// to dispatch a redux-cycle fetch against a dead legacy Drupal JSON:API endpoint and never
// actually rendered. See devportal-manager-cms-feature memory.
function DeprecatedProductMessage(props) {
  const { url } = props;

  return url ? (
    <div>
      <PopupMessage
        blurredBackground
        showCloseButton
        inFromDirection={"bottom"}
        outFromDirection={"bottom"}
        initialPosition={{
          x: "center",
          y: "center",
        }}
        visibleForSeconds={20}
        transitionInSeconds={0.5}
      >
        <h3 style={{ marginTop: 0 }}>THIS VERSION IS NO LONGER SUPPORTED</h3>
        <p>
          A newer version of this product has been released.
          <br />
          You can upgrade your subscription, by visiting the newest version.
          <br />
          <br />
        </p>
        <Link to={url}>
          <SimpleButtonWrapper style={{ display: "inline-block" }}>
            <Button electro>GO TO NEW VERSION</Button>
          </SimpleButtonWrapper>
        </Link>
      </PopupMessage>
    </div>
  ) : null;
}

export default DeprecatedProductMessage;
